import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function compareToValidator(compareControl: AbstractControl): ValidatorFn {
  return function (control: AbstractControl): ValidationErrors | null {
    const originValue = compareControl ? compareControl.value : null;
    const value = control.value;

    return originValue === value ? null : { compareTo: true };
  };
}
